const commuteTime = [
    "Menos de 15 minutos",
    "Menos de una hora",
    "Una hora",
    "Más de una hora",
    "Más de dos horas",
  ];
  
  export default commuteTime;
  